<template>
  <div class="to-top" v-if="show" @click="toTop">
    <img src="../assets/imgs/to_top.png" alt="" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapState({
      searches: state => state.home.searches,
    })
  },
  mounted() {
    const wrap = document.querySelector("#cs");
    wrap.addEventListener("scroll", this.scrollHander);
  },
  destroyed() {
    document.removeEventListener("scroll", this.scrollHander);
    // const wrap = document.querySelector("#cs");
    // wrap.scrollTop = 0;
  },
  methods: {
    scrollHander() {
      if(this.searches && this.searches.length > 0) return;
      const wrap = document.querySelector("#cs");
      let scrollTop = wrap.scrollTop;
      this.show = !!(scrollTop > 600);
    },
    toTop() {
      const wrap = document.querySelector("#cs");
      wrap.scrollTop = 0;
    }
  }
};
</script>

<style lang="less" scoped>
.to-top {
  width: 42px;
  height: 42px;
  position: fixed;
  bottom: 40px;
  right: 12px;
  z-index: 999;
  img {
    width: 42px;
    height: 42px;
  }
}
</style>
